import React, { useState } from "react";
import styled from "styled-components";
import colors from "../constatns/colors";
import useWindowDimensions from "../constatns/size";
import "../styles/home.css";
import TeamCard from "../components/TeamCard";
import GrTitle, { Title } from "../components/BgTitle";
import { Zoom } from "react-reveal";

function Gega() {
    const { width, height } = useWindowDimensions();
    const [value, setValue] = useState(0)
  return (
      <div >
          <GrTitle bgTitle={"TOKEN SYMBOL"} />
        <Title title={"GEGA"} /> 
        <Container width={width} height={height} >
            <InnerContainer width={width} height={height}>
            <Zoom>
                <TeamCard
                    title={"TBA"}
                    description={"PRIVATE SALE START"}
                    isColorBorder
                />
            </Zoom>
            <Zoom>
                <TeamCard
                    title={"$0.01/Token"}
                    description={"PRIVATE SALE"}
                    isColorBorder
                />
            </Zoom>
            <Zoom>
                <TeamCard
                    title={"500,000,000"}
                    description={"TOTAL PRIVATE SALE"}
                    isColorBorder
                />
            </Zoom>
            </InnerContainer>
            <InnerContainer width={width} height={height}>
                <Zoom>
                    <TeamCard
                        title={"TBA"}
                        description={"RESALE START"}
                        isColorBorder
                    />
                </Zoom>
                <Zoom>
                    <TeamCard
                        title={"$0.02/Token"}
                        description={"PRESALE ROUND"}
                        isColorBorder
                    />
                </Zoom>
                <Zoom>
                    <TeamCard
                        title={"500,000,000"}
                        description={"TOTAL PRESALE"}
                        isColorBorder
                    />
                </Zoom>
            </InnerContainer>
            <InnerContainer width={width} height={height}>
            
                <Zoom>
                    <TeamCard
                        title={"$0.05/Token"}
                        description={"PUBLIC PRICE"}
                        isColorBorder
                    />
                </Zoom>
                <Zoom>
                    <TeamCard
                        title={"1,000,000,000"}
                        description={"TOTAL PUBLIC SALE"}
                        isColorBorder
                    />
                </Zoom>
                <Zoom>
                    <TeamCard
                        title={"10,000,000,000"}
                        description={"MAX SUPPLY"}
                        isColorBorder
                    />
                </Zoom>
            </InnerContainer>
        </Container>
    </div>
  );
}

const Container = styled.div`
    /* display: flex; */
    padding-left: ${({width})=> width * 0.1}px;
    padding-right: ${({width})=> width * 0.1}px;
    padding-bottom: 50px;
`

const InnerContainer = styled.div`
    display: flex;
    padding-left: ${({width})=> width * 0.05}px;
    /* padding-right: ${({width})=> width * 0.1}px; */
    margin-top: ${({height})=> height * 0.05}px ;
    justify-content: space-between;
    color: ${colors.white};
    /* width: 100%; */

    @media (max-width: 768px) {
        display: block;
        margin-top: 0px ;

    }

`

const Description = styled.p`
    color: ${colors.grey};
    text-align: center;
`

export default Gega;
